import React from 'react';
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import {BrowserRouter as Router} from 'react-router-dom'
import configureStore from './store';
import './polyfills';

import App from './App';
import { unregister } from './registerServiceWorker';

const store = configureStore();

render(
  <Provider store={store}>
    <Router>
      <App/>
    </Router>
  </Provider>
  , document.getElementById('root'));

unregister();


// WEBPACK FOOTER //
// ./src/index.js